import { percentString } from "chartjs-plugin-annotation"
import React from "react"
import { PieChart, Pie, Tooltip, Cell } from "recharts"

interface DataItem {
  name: string
  students: number | null
}
interface DonutChart2Props {
  highlyActiveStudent: number | null
  inActiveStudent: number | null
  passiveActiveStudent: number | null
  activeStudent: number | null
}

const App: React.FC<DonutChart2Props> = ({
  highlyActiveStudent,
  inActiveStudent,
  passiveActiveStudent,
  activeStudent,
}) => {
  const data: DataItem[] = [
    { name: "Highly Active", students: highlyActiveStudent },
    { name: "Active", students: activeStudent },
    { name: "Partially Active", students: passiveActiveStudent },
    { name: "Inactive", students: inActiveStudent },
  ]

  const COLORS = ["#22C23A", "#FFE940", "#FFBB28", "#E26647"]

  return (
    <div className="flex justify-between items-center w-full ">
      <div style={{ textAlign: "center" }}>
        <PieChart width={273} height={273}>
          <Tooltip />
          <Pie data={data} dataKey="students" outerRadius={136.5} innerRadius={100} labelLine={false}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </div>
      <div className="flex flex-col bg-white w-1/2 ml-[1.25rem] space-y-2">
        {data.map((item, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center space-x-4 flex-1 min-w-0">
              <div
                className="w-[24px] h-[24px] rounded-[4px] shrink-0"
                style={{ backgroundColor: COLORS[index] }}
              ></div>
              <span className="text-[#000] font-inter text-[14px] font-medium leading-normal truncate">
                {item.name}
              </span>
            </div>
            <div className="flex px-[10px] py-[6px] justify-center items-center rounded-[4px] bg-[#F9F9F9] w-[71px] h-[35px] shrink-0">
              <span className="text-[#000] font-inter text-[14px] font-medium leading-normal">
                {item.students ?? "0"}%
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default App
